import { render, staticRenderFns } from "./FarmTableHeader.vue?vue&type=template&id=15e4c3b0&"
import script from "./FarmTableHeader.vue?vue&type=script&lang=ts&"
export * from "./FarmTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports